export const AnalyzeLessons = (lessonData) => {
    const userLessons = {};
  
    lessonData.forEach((lesson) => {
      const { userid, status, user } = lesson;
  
      if (!userLessons[userid]) {
        userLessons[userid] = {
          totalLessons: 0,
          completedLessons: 0,
          inProgressLessons: 0,
          pendingLessons: 0,
          userInfo: user || null
        };
      }
  
      userLessons[userid].totalLessons += 1;
  
      // Categorize lesson status
      if (status === 2) {
        userLessons[userid].completedLessons += 1;
      } else if (status === 1) {
        userLessons[userid].inProgressLessons += 1;
      } else if (status === 0) {
        userLessons[userid].pendingLessons += 1;
      }
    });
  
    return Object.values(userLessons);
  };